import { type ActionCableMixin, type Message } from '@anycable/core'
import { type CableConnectionManager } from './CableConnectionManager'
import {
  type AlmanacCableSubscriptions,
  type AlmanacCableSubscription,
  type AlmanacChannelParamsMap,
  type MessageStructure,
} from './types'

import { stringifyParams } from './utils'
import { CableSubscriptionEventHandler } from './CableSubscriptionEventHandler'

export class DebugCableSubscriptions implements AlmanacCableSubscriptions {
  constructor(readonly realThing: CableConnectionManager) {}
  create<M extends ActionCableMixin<T>, T extends Message = Message>(
    params: AlmanacChannelParamsMap,
    mixin: M,
  ): AlmanacCableSubscription {
    const channelName = params.channel
    const identifier = stringifyParams(params)
    const response = new DebugActionCableSubscription<T, M>(this.realThing, identifier, channelName, mixin)
    return response
  }
}

export class DebugActionCableSubscription<T extends Message, M extends ActionCableMixin<T>>
  implements AlmanacCableSubscription
{
  unregister = () => {}
  constructor(
    readonly realThing: CableConnectionManager,
    readonly identifier: string,
    readonly channelId: string,
    readonly mixin: M,
  ) {
    const handler = new CableSubscriptionEventHandler<T, M>(this.identifier, this.mixin ?? {})
    // Allow the subscription to remove itself
    this.unregister = this.realThing.registerHandler(this.identifier, handler)
  }
  perform(action: string, payload?: object | undefined): void {
    const message: MessageStructure = { command: 'message', identifier: this.identifier }
    if (payload != null) {
      message.data = JSON.stringify({ ...payload, action })
    } else {
      message.data = JSON.stringify({ action })
    }

    this.realThing.send(message)
  }
  send(payload: object): void {
    this.realThing.send({ identifier: this.identifier, data: JSON.stringify(payload) })
  }
  unsubscribe(): void {
    this.realThing.send({ command: 'unsubscribe', identifier: this.identifier })
    this.unregister()
  }
}
